import React from "react";
import { Row, Col } from "antd";
import "./Navbar.css";
import logo from "../../img/Saarthi-blue.png";

const NavBar = ({ menu }) => {
  return (
    <nav className="navbar">

      <Row>
        <Col span={4}>
          <a href="/"><img src={logo} className="logo" alt="logo" /></a>
        </Col>
        <Col span={20}>
          <h1>CL-Interface</h1>
        </Col>
      </Row>
    </nav>
  );
};
export default NavBar;